import { render, staticRenderFns } from "./ProductGeneralInfo.vue?vue&type=template&id=0e89ae3a&scoped=true&"
import script from "./ProductGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./ProductGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductGeneralInfo.vue?vue&type=style&index=0&id=0e89ae3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e89ae3a",
  null
  
)

export default component.exports